/* =========================================
StudentTcDetails.jsx
========================================= */

import React, {
  useEffect,
  useState
} from "react";

import {
  useParams
} from "react-router-dom";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const StudentTcDetails = () => {
  const [open, setOpen] =
    useState(false);

  const [data, setData] =
    useState([]);

  const { id } =
    useParams();

  useEffect(() => {
    fetch(
      ` https://node.ilakshyaerp.in/api/student-tc/class/${id}`
    )
      .then((res) =>
        res.json()
      )
      .then((res) =>
        setData(
          Array.isArray(res)
            ? res
            : []
        )
      );
  }, [id]);

  const downloadFile =
    async (
      file,
      name
    ) => {
      const url = ` https://node.ilakshyaerp.in/uploads/student-tc/${file}`;

      const res =
        await fetch(
          url
        );

      const blob =
        await res.blob();

      const link =
        document.createElement(
          "a"
        );

      link.href =
        window.URL.createObjectURL(
          blob
        );

      link.download =
        name;

      link.click();
    };

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      <div className="container">

        <div className="gallery-section">
          <h2 className="gallery-title">
            Student TC Records
          </h2>
        </div>

        <div className="pdf-grid">

          {data.map(
            (item) => {
              const url = ` https://node.ilakshyaerp.in/uploads/student-tc/${item.file}`;

              return (
                <div
                  key={
                    item.id
                  }
                  className="pdf-card"
                >

                  {/* PDF ICON CLICK = PREVIEW */}
                  <a
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    className="pdf-icon"
                    title="Preview File"
                  >
                    📄
                  </a>

                  <h3>
                    {
                      item.student_name
                    }
                  </h3>

                  <p>
                    Roll No :
                    {
                      item.roll_no
                    }
                  </p>

                  <div className="pdf-btns">

                    <button
                      className="download-btn"
                      onClick={() =>
                        downloadFile(
                          item.file,
                          item.student_name
                        )
                      }
                    >
                      Download
                    </button>

                  </div>

                </div>
              );
            }
          )}

        </div>

      </div>

      <Footer />
    </>
  );
};

export default StudentTcDetails;